angular.module('cfn').controller('settingsPlantController', [
  '$scope',
  function($scope) {
    return app.farmnetControllers.finishController(
      'settingsPlantController',
      $scope,
      this
    );
  }
]);
